import React from "react";
import "./Footer.scss";
import { RiCopyrightFill } from "react-icons/ri";
import { Fade } from "react-reveal";

const Footer = () => {
  return (
    <>
      <div className="footer-area">
        <Fade>
          <div className="container text-center text-light py-5">
            <p className="custom-font fs-5 mt-3">
              Designed and developed by{" "}
              <span className="name-span">Rafi Ferdos</span>
            </p>
            <p className="custom-font">
              <RiCopyrightFill className="copyright-icon" /> 2021{" "}
              <span className="divider-span">|</span>All Rights Reserved
            </p>
          </div>
        </Fade>
      </div>
    </>
  );
};

export default Footer;
